import {useFetchAllObjs} from "../../platform/hooks/PlatformTypeScriptHooks";
import {BladeProfileReportJson, BladeProfileReportJsonEntry} from "../impeller/AdjustableImpellerService";


export interface BladeProfileJson {
    name: string,
    displayName: string,
    minDiameter: number,
    maxDiameter: number,
    minBladeEndSpeed: number,
    maxBladeEndSpeed: number,
};

export function useFetchAllBladeProfiles(): BladeProfileReportJsonEntry[] | null {
    return useFetchAllObjs<BladeProfileReportJson>("/api/blade-profiles-report")?.entries ?? null;
}

